import { render, staticRenderFns } from "./WidgetBrands.vue?vue&type=template&id=40356728"
import script from "./WidgetBrands.vue?vue&type=script&lang=js"
export * from "./WidgetBrands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports